var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgTutorialLearningIcon = function SvgTutorialLearningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Menu/ Learning")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu/Learning",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 5C0.75 2.65279 2.65279 0.75 5 0.75H22C22.6904 0.75 23.25 1.30964 23.25 2V23C23.25 23.6904 22.6904 24.25 22 24.25H5C2.65279 24.25 0.75 22.3472 0.75 20V5Z",
    stroke: "#B2B2B2",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.857178 18.9655C0.857178 18.9655 2.93027 17.2413 5.52163 17.2413C8.11299 17.2413 23.1429 17.2413 23.1429 17.2413",
    stroke: "#B2B2B2",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.75,
    y1: 1,
    x2: 5.75,
    y2: 17,
    stroke: "#B2B2B2",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 21.75,
    x2: 8,
    y2: 21.75,
    stroke: "#B2B2B2",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 19.75,
    x2: 8,
    y2: 19.75,
    stroke: "#B2B2B2",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6799 10.6159L15.5 12.4325V1H20.5V12.4325L18.3201 10.6159L18 10.3491L17.6799 10.6159Z",
    stroke: "#B2B2B2"
  }))));
};

export default __webpack_public_path__ + "static/media/tutorial-learning-icon.28b834e8.svg";
export { SvgTutorialLearningIcon as ReactComponent };